import * as constants from './constants';
import { guardNullOrUndefined } from '../utils/guards';

export const fetchFeaturedAdRequest = featuredAdId => ({
  type: constants.FETCH_FEATURED_AD_REQUEST,
  payload: { featuredAdId },
});

export const resetFeaturedAd = () => ({
  type: constants.RESET_FEATURED_AD,
});

export const fetchFeaturedAdStart = () => ({
  type: constants.FETCH_FEATURED_AD_START,
});

export const fetchFeaturedAdSuccess = featuredAd => {
  guardNullOrUndefined(featuredAd);
  return {
    type: constants.FETCH_FEATURED_AD_SUCCESS,
    payload: { featuredAd },
  };
};

export const fetchFeaturedAdFailed = error => {
  guardNullOrUndefined(error);
  return {
    type: constants.FETCH_FEATURED_AD_FAILED,
    payload: { error },
  };
};



// WEBPACK FOOTER //
// ./app/FeaturedAd/actions.js